import {environment} from '../environment'
import axios from 'axios';
import { useBasicAuth } from '../../shared/components/auth/withBasicAuth';

const urlAPI = environment.getApi('geometryShapesEstadoArea');

export const check = () => useBasicAuth.checkToken();

export const findAllGeometryAreaByEstado = (id) => 
  axios.get(urlAPI + "/byEstado/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });
